import B2ChatClient from '@client-sdk';
import {
  fetchUserActivityTimeout,
  fetchUserActivityTimeoutFailure,
  fetchUserActivityTimeoutFulfill,
  fetchUserActivityTimeoutSuccess,
} from '@src/reducers/userActivity';
import { B2ChatAPI } from '@types-api';
import { call, put, takeLatest } from 'redux-saga/effects';

function* fetchUserActivityTimeoutSaga() {
  try {
    const response: B2ChatAPI.Response<number> = yield call(
      B2ChatClient.resources.userConfig.actions.getInactivityTimeout,
      {}
    );

    const { error } = response;
    if (!error) {
      const timeInMiliSeconds = Number(response.data) * 60 * 1000;
      yield put(fetchUserActivityTimeoutSuccess(timeInMiliSeconds));
    } else {
      throw error;
    }
  } catch (error: unknown) {
    yield put(
      fetchUserActivityTimeoutFailure({
        message: (error as Error)?.message,
        errorCode: 'fetchUserActivityTimeout',
        status: 403,
      })
    );
  } finally {
    yield put(fetchUserActivityTimeoutFulfill());
  }
}

function* botAccounts() {
  yield takeLatest(fetchUserActivityTimeout, fetchUserActivityTimeoutSaga);
}

export default botAccounts;
